/**
 * Inspiration Flip Cards Module
 * Obsługuje flip kart inspiracji na stronie konkurs-bittersweet.
 * Klik/tap w kartę lub trigger toggleuje klasę .is-flipped.
 *
 * Na stronie konkurs-one2one: użytkownik może odsłonić TYLKO jedną kartę.
 * Po odsłonięciu:
 *  - pozostałe karty wygasają (opacity 0 + scale down)
 *  - wybrana karta przesuwa się na środek (translateX)
 *  - przycisk formularza zmienia tekst na "Wyślij zgłoszenie"
 */

(function () {
  'use strict';

  var SELECTOR = '[data-inspiration-flip]';
  var CLASS_FLIPPED = 'is-flipped';
  var CLASS_LOCKED = 'is-locked';
  var CLASS_HAS_SELECTION = 'has-selection';

  function init() {
    var cards = document.querySelectorAll(SELECTOR);
    if (!cards.length) return;

    // Sprawdź, czy to strona one2one (pick-one mode)
    var isPickOne = document.body.classList.contains('page-konkurs-one2one');

    // Referencja do gridu i przycisku submit
    var grid = document.querySelector('.contest-inspiration__grid');
    var submitBtn = document.getElementById('contest-submit-btn');

    // ---- Logika przycisku formularza (one2one) ----
    if (isPickOne && submitBtn) {
      setupSubmitButton(submitBtn);
    }

    cards.forEach(function (card) {
      function flipCard(e) {
        if (e) {
          e.preventDefault();
          e.stopPropagation();
        }

        // Jeśli karta jest zablokowana — nic nie rób
        if (card.classList.contains(CLASS_LOCKED)) return;

        if (isPickOne) {
          // Tryb pick-one: pozwól flip tylko jeśli żadna karta jeszcze nie jest odwrócona
          var anyFlipped = Array.prototype.some.call(cards, function (c) {
            return c.classList.contains(CLASS_FLIPPED);
          });

          // Jeśli jakakolwiek karta jest już odwrócona — blokuj wszelkie akcje
          if (anyFlipped) return;

          // 1. Oblicz offset do wycentrowania karty
          var offsetX = calculateCenterOffset(card, grid);

          // 2. Flip wybranej karty
          card.classList.add(CLASS_FLIPPED);

          // 3. Przesuń wybraną kartę na środek (po 1 klatce, żeby transition zadziałał)
          requestAnimationFrame(function () {
            card.style.transform = 'translateX(' + offsetX + 'px)';

            // 4. Wygaś pozostałe karty + oznacz grid
            cards.forEach(function (c) {
              if (c !== card) {
                c.classList.add(CLASS_LOCKED);
              }
            });

            if (grid) {
              grid.classList.add(CLASS_HAS_SELECTION);
            }

            // 5. Na mobile: po zakończeniu animacji zwijania, focus na wybraną kartę
            if (window.innerWidth < 1024) {
              setTimeout(function () {
                card.scrollIntoView({ behavior: 'smooth', block: 'center' });
              }, 750);
            }
          });

          // 5. Zmień tekst przycisku na "Wyślij zgłoszenie"
          if (submitBtn) {
            submitBtn.textContent = 'Wyślij zgłoszenie';
            submitBtn.setAttribute('data-card-selected', 'true');
            submitBtn.type = 'submit';
          }
        } else {
          // Tryb domyślny (bittersweet) — toggle
          card.classList.toggle(CLASS_FLIPPED);
        }
      }

      // Klik w trigger
      var triggers = card.querySelectorAll('.contest-inspiration__flip-trigger');
      triggers.forEach(function (trigger) {
        trigger.addEventListener('click', flipCard);
      });

      // Klik w kartę (ale nie w trigger)
      card.addEventListener('click', function (e) {
        if (e.target.closest('.contest-inspiration__flip-trigger')) return;
        flipCard(e);
      });
    });
  }

  /**
   * Oblicza przesunięcie X potrzebne, żeby karta znalazła się na środku gridu.
   * Bierze pod uwagę aktualną pozycję karty i środek gridu.
   */
  function calculateCenterOffset(card, grid) {
    if (!grid) return 0;

    var gridRect = grid.getBoundingClientRect();
    var cardRect = card.getBoundingClientRect();

    // Środek gridu
    var gridCenterX = gridRect.left + gridRect.width / 2;

    // Środek karty
    var cardCenterX = cardRect.left + cardRect.width / 2;

    // Offset do przesunięcia
    return gridCenterX - cardCenterX;
  }

  /**
   * Logika przycisku submit:
   * - Jeśli karta nieodkryta → tekst "Najpierw odkryj kartę", klik scrolluje do sekcji kart
   * - Jeśli karta odkryta → tekst "Wyślij zgłoszenie", normalny submit
   */
  function setupSubmitButton(btn) {
    btn.addEventListener('click', function (e) {
      var isCardSelected = btn.getAttribute('data-card-selected') === 'true';

      if (!isCardSelected) {
        // Karta nieodkryta — scroll do sekcji kart
        e.preventDefault();

        var inspirationSection = document.getElementById('contest-inspiration');
        if (inspirationSection) {
          var navbar = document.querySelector('.navbar');
          var navbarH = navbar ? navbar.offsetHeight : 0;
          var top = inspirationSection.getBoundingClientRect().top + window.pageYOffset - navbarH;
          window.scrollTo({ top: top, behavior: 'smooth' });
        }
      }
      // Jeśli karta odkryta — nie robimy preventDefault, formularz działa normalnie
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
